/* Parbiart — a mega menü panelje csak akkora, amekkora a tartalma (parbiart.css 6.), és középre igazodik:
   a nagy a menüsor közepére, a kisebb a saját menüpontja alá. Ha így kilógna a képernyőről, annyival csúszik, hogy beférjen.
   Szkript nélkül a panel a fejléc közepén jelenik meg (a CSS alapértéke) — úgy is használható. */
(function () {
  'use strict';
  var RES = 16; // legalább ennyi hely marad a képernyő szélétől (px)

  function igazit(d) {
    var panel = d.querySelector('.mega-menu__content');
    var pont = d.querySelector('summary');
    if (!panel || !pont || !d.open) return;
    var szulo = panel.offsetParent || document.body;
    var sz = szulo.getBoundingClientRect();
    var w = panel.getBoundingClientRect().width;
    // Norbi 10-06: a nagy panel (szélesebb a menüsornál — az Otthon) a menüsor közepére kerül,
    // a kisebb a saját menüpontja közepe alá
    var nav = d.closest('.header__inline-menu');
    var n = (nav || pont).getBoundingClientRect();
    var mihez = w >= n.width ? n : pont.getBoundingClientRect();
    var bal = mihez.left + mihez.width / 2 - w / 2;
    bal = Math.min(bal, sz.right - RES - w);                 // jobbra ne lógjon ki
    bal = Math.max(bal, sz.left + RES);                      // balra se
    panel.style.left = Math.round(bal - sz.left) + 'px';
    panel.style.translate = '0 0';
  }
  function mind() {
    Array.prototype.forEach.call(document.querySelectorAll('details.mega-menu[open]:not(.pb-mega--kicsi)'), igazit);
  }
  // a <details> „toggle" eseménye nem buborékol — elfogó figyelővel egy helyen kezelhető
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.matches && d.matches('details.mega-menu:not(.pb-mega--kicsi)')) igazit(d);
  }, true);
  window.addEventListener('resize', mind);
})();
